var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatestMethods(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "#0E121A",
    stroke: "#775DDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_974_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3438 30C43.3438 37.3562 37.3562 43.3438 30 43.3438C22.6438 43.3438 16.6562 37.3562 16.6562 30C16.6562 22.6438 22.6437 16.6562 30 16.6562C37.3563 16.6562 43.3438 22.6438 43.3438 30ZM42.7896 30C42.7896 22.9455 37.0544 17.2104 30 17.2104C22.9456 17.2104 17.2104 22.9455 17.2104 30C17.2104 37.0545 22.9455 42.7896 30 42.7896C37.0545 42.7896 42.7896 37.0545 42.7896 30Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0833 34.4614C34.256 34.6013 34.4613 34.6667 34.6666 34.6667C34.942 34.6667 35.2126 34.5454 35.3946 34.3167C35.7166 33.9154 35.6512 33.3274 35.25 33.0054L30.9333 29.552V22.5334C30.9333 22.02 30.5133 21.6 30 21.6C29.4866 21.6 29.0667 22.02 29.0667 22.5334V30.0001C29.0667 30.2847 29.1973 30.5507 29.4166 30.728L34.0833 34.4614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_974_1096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestMethods);
export default __webpack_public_path__ + "static/media/latestMethods.0a9b12561f2f1b790360919334601a82.svg";
export { ForwardRef as ReactComponent };